import { render, staticRenderFns } from "./CustomerRequestDetail.vue?vue&type=template&id=ce454c50&"
import script from "./CustomerRequestDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports